<template>
  <base-display-widget
    id="ssssss"
    :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
    :phoneHeight="phoneHeight"
    :style="{height:phoneHeight + 'px'}">
    <div class="h-full" ref="phone">
      <div style="min-height: 72px;width: 100%;" v-if="iteminfo.config.displayType === 1">
        <ul class="flex j-start flex-wrap p-4">
          <li :key="index" class="p-4 flex-s-0" style="width: 50%"
              v-for="(item,index) in getshowDataList">
            <ratio-div :RadioValue="40">
              <div class="w-full h-full absolute top-0 left-0 flex a-center o-hidden">
                <img :src="getdefaultnavImg(item)" class="w-full"
                     style="cursor: pointer"/>
              </div>
            </ratio-div>
          </li>
        </ul>
      </div>
      <div class="bg-white" style="min-height: 90px" v-if="iteminfo.config.displayType === 2">
        <ul class="flex j-start flex-wrap p-v-10 p-h-10">
          <li :key="index" class="p-4 flex-s-0" style="width: 25%"
              v-for="(item,index) in getshowDataList">
            <ratio-div :RadioValue="100">
              <div class="w-full h-full absolute top-0 left-0 flex-column a-center j-center">
                <div class="w-p-60 h-p-60 flex a-center j-center o-hidden">
                  <img :src="getdefaultnavImg(item)"
                       style="cursor: pointer;min-height: 100%"/>
                </div>
                <div class="m-t-5" style="cursor: pointer">
                  {{ item.title || '导航' + (index + 1) }}
                </div>
              </div>
            </ratio-div>
          </li>
        </ul>
      </div>
      <div  v-if="iteminfo.config.displayType === 3">
        <Carousel :autoplay="false" :dots="'inside'" :loop="false"
                  ref="carousel"
                  id="car"
                  :radiusDot="true"
                  v-model:value="carouselIndex"
                  :arrow="'never'">
          <CarouselItem :key="index" v-for="(item,index) in getshowDataList"
                      >
            <img class="w-full h-full" src="../../../assets/common/img_ohter_guide@2x.png"
                 :style="{height:phoneHeight + 'px'}"
                 style="width: 100%"
                 v-if="!item.picurl"/>
            <img :src="getdefaultnavImg(item)"
                 v-if="item.picurl"
                 :style="{height:phoneHeight + 'px'}"
                 style="cursor: pointer;object-fit:cover;width: 100%"
            />
          </CarouselItem>
        </Carousel>
      </div>

    </div>
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import RatioDiv from '../../common/RatioDiv'

export default {
  name: 'GuideDisplayWidget',
  components: {RatioDiv, BaseDisplayWidget},
  props: {
    iteminfo: Object,
    phoneHeight:{
      type:Number,
      default:0
    }
  },
  setup (props, context) {

  },
  data () {
    return {
      carouselIndex: 0,
      height: 720,
      listener: null,
    }
  },
  computed: {
    getshowDataList () {
      let list = []
      // list = this.getDefaultProductList()
      list = this.iteminfo.config.datalist
      //避免index越界,白屏
      if (this.carouselIndex > list.length - 1) {
        this.carouselIndex = list.length - 1
      } else if (this.carouselIndex < 0) {
        this.carouselIndex = 0
      }

      return list
    },
  },
  mounted () {
    this.init()
  },
  // watch: {
  //   iteminfo: {
  //     handler (newV) {
  //       if (newV.datalist.length - 1 < this.$refs.carousel.trackIndex) {
  //         this.carouselIndex = 0
  //       }
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    init () {
      //手机的宽高..
      this.height = this.$refs.phone.clientHeight
      this.width = this.$refs.phone.clientWidth
      window.onresize = () => {
        this.height = this.$refs.phone.clientHeight
        this.width = this.$refs.phone.clientWidth
      }

      //点击左右切换
      let car = document.getElementById('car')

      this.listener = ev => {
        let left = car.getBoundingClientRect().x
        let x = ev.x - left
        let trackIndex = this.$refs.carousel.trackIndex
        if (x < (this.width / 2) && trackIndex > 0) {
          this.carouselIndex -= 1
        } else if (x > (this.width / 2) && trackIndex < this.getshowDataList.length - 1) {
          this.carouselIndex += 1
        }
      }
      car.addEventListener('click', this.listener)
    },
    getdefaultnavImg (item) {
      let src = require('../../../assets/tempmenu/img_picture_abreast.png')
      if (this.iteminfo.config.displayType === 1) {
        src = require('../../../assets/tempmenu/img_nav_card.png')
      } else if (this.iteminfo.config.displayType === 2) {
        src = require('../../../assets/tempmenu/img_nav_icon.png')
      } else if (this.iteminfo.config.displayType === 3) {
        src = require('../../../assets/tempmenu/img_carousel.png')
      }
      if (item.picurl) {
        src = item.picurl
      }
      return src
    },
    getDefaultProductList () {
      let templist = []
      let length = 1
      if (this.iteminfo.config.displayType === 1) {
        length = 4
      } else if (this.iteminfo.config.displayType === 2) {
        length = 8
      } else if (this.iteminfo.config.displayType === 3) {
        length = 4
      }
      let len = this.iteminfo.config.datalist.length || 0
      if (length <= len) {
        templist = this.iteminfo.config.datalist
      } else {
        templist = templist.concat(this.iteminfo.config.datalist)
        for (let i = 0; i < (length - len); i++) {
          templist.push({
            id: 0,
            picurl: '',
            title: ''
          })
        }
      }
      return templist
    },
    destroy () {
      let car = document.getElementById('car')
      car.removeEventListener('click', this.listener)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
